/**
 * @ is an editor-only image picker trigger. Selected images are stored solely
 * as {{ImageN}} tokens by the image-reference placeholder contract.
 */
export function findWorkspaceImageMentionQuery(
  prompt: string,
  caretOffset: number
) {
  const safeOffset = Math.max(0, Math.min(caretOffset, prompt.length));
  const prefix = prompt.slice(0, safeOffset);
  const match = prefix.match(/@([a-z0-9]*)$/i);
  if (!match) return null;

  return {
    start: safeOffset - match[0].length,
    end: safeOffset,
    query: match[1] ?? '',
  };
}
